import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import featureFlags from 'shared/lib/featureFlags';
import rootReducerFn from 'userportal/rootReducer';
import alertMiddleware from 'userportal/middleware/alertMiddleware';
import apiMiddleware from 'userportal/middleware/apiMiddleware';
import authMiddleware from 'userportal/middleware/authMiddleware';

export { history } from 'userportal/history';

const rootReducer = rootReducerFn();

const noopMiddleware = () => next => action => next(action);

export default function (initialState) {
  const logger = createLogger();
  const enhancer = window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && featureFlags.logger
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
  const finalCreateStore = enhancer(
    applyMiddleware(
      apiMiddleware,
      authMiddleware,
      alertMiddleware,
      featureFlags.logger ? logger : noopMiddleware
    )
  )(createStore);

  return finalCreateStore(rootReducer, initialState);
}
